var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.$baseFilePath))]),_c('p',[_vm._v(_vm._s(_vm.$axios.defaults.baseURL))]),_c('p',[_vm._v("Git Commit Frontend: "+_vm._s(_vm.hash))])])}
var staticRenderFns = []

export { render, staticRenderFns }